import React from 'react'
import { View } from '@components/atoms'

import {
	useAppSelector,
	useAppDispatch,
	paymentActions,
	PaymentDeliveryType,
	PaymentStateType,
} from '@redux/index'

/**
 * 카드 결제 실행 — Monolith(2안). 구 구현은 `systems/payment/CardPaymentButton.tsx`.
 *
 * 원화/달러 분기와 트리거 액션은 구 구현 그대로다. MUI contained 버튼을 페이지의 유일한
 * 블랙 CTA(§5)로 바꾸고, 검증 실패 문구를 `.mnError` 로 옮겼다.
 */
export const MonolithCardPaymentButton = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const delivery: PaymentDeliveryType = useAppSelector(
		state => state.payment.paymentDelivery,
	)
	const errorMessages: PaymentStateType['paymentErrorMessages'] = useAppSelector(
		state => state.payment.paymentErrorMessages,
	)

	const isKrwPayment: boolean = React.useMemo(
		() => delivery.countryIsoCode === 'KR',
		[delivery],
	)

	const onPay = () => {
		if (isKrwPayment) {
			// 원화 결제
			reduxDispatch(paymentActions.TRIGGER_KRW_PAY_NOW(true))
		} else {
			// 달러 결제
			reduxDispatch(paymentActions.TRIGGER_USD_PAY_NOW(true))
		}
	}

	return (
		<View className="mnPayAction">
			<button type="button" className="mnCta mnPayCta" onClick={onPay}>
				Pay now
			</button>

			{!errorMessages.isSuccess && (
				<span className="mnError">
					{isKrwPayment
						? '필수 항목에 빠진 부분이 없는지 확인하시고 잘못 기입된 부분을 수정해주세요.'
						: 'Some required fields may be missing, or certain inputs may be in an incorrect format.'}
				</span>
			)}
		</View>
	)
}
